<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">
        <div class="form-group row justify-content-center">
          <app-input [label]="'dateEnd'" type="date" [formControl]="form_end" [size]="12"></app-input>
        </div>
      </form>
    </div>
  </div>
</ng-template>